import { COOKIE_CONSENT_KEY } from '@app/config/const'
import StorageServices from '@services/local.storage'
import ReactGA from 'react-ga'

export { COOKIE_CONSENT_KEY }

export type ConsentValue = 'accepted' | 'declined'

export const getConsent = (): ConsentValue | null => {
  const value = StorageServices.getData<ConsentValue | null>(
    COOKIE_CONSENT_KEY,
    null
  )
  return value === 'accepted' || value === 'declined' ? value : null
}

export const setConsent = (value: ConsentValue): void => {
  StorageServices.setData(COOKIE_CONSENT_KEY, value)
}

const GA_COOKIE_NAMES = ['_ga', '_gid', '_gat']

export const clearGACookies = (): void => {
  const hostname = window.location.hostname
  const domains = [hostname, `.${hostname}`]
  const rootDomain = hostname.split('.').slice(-2).join('.')
  if (rootDomain && rootDomain !== hostname) {
    domains.push(rootDomain, `.${rootDomain}`)
  }

  GA_COOKIE_NAMES.forEach((name) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`
    domains.forEach((domain) => {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domain}`
    })
  })

  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith('_ga')) {
      localStorage.removeItem(key)
    }
  })
}

export const initGA = (trackingId: string): void => {
  ReactGA.initialize(trackingId)
  ReactGA.pageview(window.location.pathname)
}
